import ThreadsValidator from '~publish/legacy/composer/composer/lib/validation/ThreadsValidator'

export default class MastodonValidator extends ThreadsValidator {}
